import { styled } from "goober";
import { Icon, type IconName } from "./Icon";
import { Text } from "./Text";

const Outer = styled("div")`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Inner = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px;
  text-align: center;
`;

const IconContainer = styled("div")`
  opacity: 0.1;
`;

const TextContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

type Props = {
  title: string;
  description?: string;
  maxWidth?: number;
  action?: React.ReactNode;
} & (
  | { iconName: IconName; iconSize?: 24 | 36; icon?: never }
  | { icon: React.ReactNode; iconName?: never; iconSize?: never }
);

export function EmptyState({
  title,
  description,
  maxWidth = 320,
  action,
  ...rest
}: Props) {
  return (
    <Outer>
      <Inner style={{ width: maxWidth }}>
        {"icon" in rest && rest.icon ? (
          rest.icon
        ) : (
          <IconContainer>
            <Icon
              name={"iconName" in rest ? rest.iconName! : "rabbit"}
              size={("iconSize" in rest && rest.iconSize) || 36}
              color="var(--text-primary)"
            />
          </IconContainer>
        )}
        <TextContainer>
          <Text variant="text-regular-md" color="var(--text-primary)">
            {title}
          </Text>
          {description && (
            <Text variant="text-regular" color="var(--text-secondary)">
              {description}
            </Text>
          )}
        </TextContainer>
        {action}
      </Inner>
    </Outer>
  );
}
